import { graphql } from '../__generated__/gql';

export const GET_ECOW_ISOLATION_BY_PERMIT_NUMBER = graphql(/* GraphQL */ `
  query EcowIsolation($permitNumber: String!) {
    ecowIsolation(permitNumber: $permitNumber) {
      isolationNumber
      projectCode
      statusComment
      siteCode
      processIsolaitonPoints
      elecLV1IsolationPoints
      instrumentIsolationPoints
      elecLV2IsolationPoints
      elecHVIsolationPoints
      totalIsolationPoints
    }
  }
`);

export const GET_ALL_ISOLATIONS = graphql(/* GraphQL */ `
  query Isolations($assetId: Int!) {
    allIsolations(assetId: $assetId) {
      isolationId
      loshNumber
      title
      drawingStatus
      fieldWalked
      isolationNumber
      requiredTrades
      source
      totalHours
      lineWalkPackStatus
      packNumber
      comments
      updatedAt
      updatedBy
      ecowIsolation {
        isolationNumber
        projectCode
        statusComment
        siteCode
        processIsolaitonPoints
        elecLV1IsolationPoints
        instrumentIsolationPoints
        elecLV2IsolationPoints
        elecHVIsolationPoints
        totalIsolationPoints
        lastModifiedTime
      }
      tarJobs {
        jobId
        eventId
      }
    }
  }
`);

export const GET_JOB_ISOLATIONS = graphql(/* GraphQL */ `
  query JobIsolations($jobId: Int!) {
    isolationsByJobId(jobId: $jobId) {
      isolationId
      loshNumber
      title
      drawingStatus
      fieldWalked
      isolationNumber
      requiredTrades
      source
      totalHours
      lineWalkPackStatus
      packNumber
      comments
      updatedAt
      updatedBy
      ecowIsolation {
        isolationNumber
        projectCode
        statusComment
        siteCode
        processIsolaitonPoints
        elecLV1IsolationPoints
        instrumentIsolationPoints
        elecLV2IsolationPoints
        elecHVIsolationPoints
        totalIsolationPoints
        lastModifiedTime
      }
      tarJobs {
        jobId
      }
    }
  }
`);

export const GET_ISOLATIONS_BY_ISOLATION_NUMBERS = graphql(/* GraphQL */ `
  query IsolationsByIsolationNumbers($isolationNumbers: [String!]) {
    isolationsByIsolationNumbers(isolationNumbers: $isolationNumbers) {
      isolationNumber
      statusComment
    }
  }
`);

export const CREATE_ISOLATION = graphql(/* GraphQL */ `
  mutation CreateIsolation($input: IsolationInput!) {
    createIsolation(input: $input) {
      isolationId
    }
  }
`);

export const UPDATE_ISOLATION = graphql(/* GraphQL */ `
  mutation UpdateIsolation($input: IsolationInput!) {
    updateIsolation(input: $input) {
      isolationId
    }
  }
`);

export const LINK_ISOLATION_JOBS = graphql(/* GraphQL */ `
  mutation LinkIsolationJobs($isolationId: Int!, $jobIds: [Int]!) {
    linkIsolationJobs(isolationId: $isolationId, jobIds: $jobIds) {
      isolationId
    }
  }
`);

export const REMOVE_ISOLATION = graphql(/* GraphQL */ `
  mutation RemoveIsolation($isolationId: Int!) {
    removeIsolation(isolationId: $isolationId)
  }
`);
